

import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import Menu from "../components/shop/ShopItem";
import Banner from "../components/banner/Banner";
import "../components/cart/Cart.css"
import { useEffect } from "react";

const Shop = () => {
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <div className="bg-imagea">
            <Navbar />
            <Banner title="Shop" />
            <Menu />
            <Footer />
        </div>
    )
}
export default Shop;